import { render, staticRenderFns } from "./ProjectMonitoringReadOnlyView.vue?vue&type=template&id=0a26c148&scoped=true&"
import script from "./ProjectMonitoringReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectMonitoringReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a26c148",
  null
  
)

export default component.exports